/* FF signup source tracking (added 2026-11-01, Claude, at Ben's direction).
   Records where each visitor came from (UTMs, fbclid/gclid, referrer) and, when
   someone signs up in the Alia popup, writes that source onto their Klaviyo
   profile (ff_signup_* = the visit they signed up on, ff_first_* = their first
   visit since this script went live) and logs a Klaviyo event
   "FF Popup Signup Source". Uses the Klaviyo onsite embed already on the theme.
   Does not touch the Meta Lead listener above. */
(function () {
  var FIRST = 'ff_src_first_v1', SESS = 'ff_src_sess_v1', DAYS = 90;
  function host(u) { try { return new URL(u).hostname.replace(/^www\./, '').toLowerCase(); } catch (e) { return ''; } }
  function q() { try { return new URLSearchParams(window.location.search); } catch (e) { return { get: function () { return null; } }; } }
  function channelOf(t) {
    var s = (t.utm_source || '').toLowerCase(), m = (t.utm_medium || '').toLowerCase(), r = t.referrer_host || '';
    if (t.fbclid || /^(fb|facebook|ig|instagram|meta)$/.test(s) || /facebook|instagram|meta/.test(s)) return t.fbclid || /paid|cpc|ads?/.test(m) ? 'meta_ads' : 'meta';
    if (t.kx || m === 'email' || /klaviyo/.test(s)) return 'email';
    if (m === 'sms' || /attentive|postscript/.test(s)) return 'sms';
    if (t.gclid || (/google/.test(s) && /cpc|paid/.test(m))) return 'google_ads';
    if (t.ttclid || /tiktok/.test(s)) return 'tiktok';
    if (s) return 'utm:' + s;
    if (/facebook\.com|instagram\.com|fb\.me|l\.facebook|lm\.facebook/.test(r)) return 'meta_organic';
    if (/google\.|bing\.|yahoo\.|duckduckgo\.|ecosia\./.test(r)) return 'search';
    if (/youtube\.com/.test(r)) return 'youtube';
    if (/tiktok\.com/.test(r)) return 'tiktok';
    if (r) return 'referral:' + r;
    return 'direct';
  }
  function touchNow() {
    var p = q(), ref = document.referrer || '', rh = host(ref);
    if (rh && rh === host(window.location.href)) { rh = ''; ref = ''; }
    var t = {
      utm_source: p.get('utm_source') || '', utm_medium: p.get('utm_medium') || '',
      utm_campaign: p.get('utm_campaign') || '', utm_content: p.get('utm_content') || '',
      utm_term: p.get('utm_term') || '', fbclid: p.get('fbclid') ? '1' : '',
      gclid: p.get('gclid') ? '1' : '', ttclid: p.get('ttclid') ? '1' : '', kx: p.get('_kx') ? '1' : '',
      referrer_host: rh, landing: window.location.pathname, at: new Date().toISOString()
    };
    t.channel = channelOf(t);
    return t;
  }
  function get(store, k) { try { return JSON.parse(store.getItem(k) || 'null'); } catch (e) { return null; } }
  function put(store, k, v) { try { store.setItem(k, JSON.stringify(v)); } catch (e) {} }
  try {
    if (window.Shopify && window.Shopify.designMode) return;
    var now = touchNow();
    var sess = get(sessionStorage, SESS);
    if (!sess || (now.channel !== 'direct' && now.channel !== sess.channel && (now.utm_source || now.fbclid || now.gclid || now.kx))) {
      put(sessionStorage, SESS, now); sess = now;
    }
    var first = get(localStorage, FIRST);
    if (!first || !first.at || (Date.now() - Date.parse(first.at)) > DAYS * 864e5) { put(localStorage, FIRST, now); first = now; }
  } catch (e) {}

  document.addEventListener('alia:signup', function (e) {
    try {
      var d = (e && e.detail) || {};
      var s = get(sessionStorage, SESS) || touchNow(), f = get(localStorage, FIRST) || s;
      var props = {
        ff_signup_source: s.channel, ff_signup_utm_source: s.utm_source, ff_signup_utm_medium: s.utm_medium,
        ff_signup_utm_campaign: s.utm_campaign, ff_signup_utm_content: s.utm_content,
        ff_signup_referrer: s.referrer_host, ff_signup_landing: s.landing, ff_signup_page: window.location.pathname,
        ff_signup_at: new Date().toISOString(),
        ff_first_source: f.channel, ff_first_utm_source: f.utm_source, ff_first_utm_campaign: f.utm_campaign,
        ff_first_landing: f.landing, ff_first_at: f.at
      };
      var who = {};
      if (d.email) who.email = String(d.email).trim().toLowerCase();
      if (d.phone) who.phone_number = String(d.phone).trim();
      if (!who.email && !who.phone_number) return;
      window.klaviyo = window.klaviyo || [];
      var idp = {}; for (var k in who) idp[k] = who[k]; for (var k2 in props) idp[k2] = props[k2];
      window.klaviyo.push(['identify', idp]);
      window.klaviyo.push(['track', 'FF Popup Signup Source', props]);
    } catch (err) {}
  });
})();
